import React from "react";

export default function TemplatePagination({
  page,
  setPage,
  total,
  itemsPerPage
}) {
  const totalPages = Math.ceil(total / itemsPerPage);

  const pageGroupSize = 5; // 한 번에 보여줄 페이지 개수

  const currentGroup = Math.ceil(page / pageGroupSize);

  const startPage = (currentGroup - 1) * pageGroupSize + 1;
  const endPage = Math.min(startPage + pageGroupSize - 1, totalPages);


  return (
    <div className="regul-template-pagination">

      {/* 이전 */}
      <button
        className="regul-template-page-btn"
        onClick={() => setPage(1)}
        disabled={page === 1}
      >
        {"<<"}
      </button>

      <button
        className="regul-template-page-btn"
        onClick={() => setPage(page - 1)}
        disabled={page === 1}
      >
        {"<"}
      </button>

      {/* 페이지 번호 */}
      {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map(num => (
        <button
          key={num}
          className={`regul-template-page-btn ${page === num ? "active" : ""}`}
          onClick={() => setPage(num)}
        >
          {num}
        </button>
      ))}

      {/* 다음 */}
      <button
        className="regul-template-page-btn"
        onClick={() => setPage(page + 1)}
        disabled={page === totalPages}
      >
        {">"}
      </button>

      <button
        className="regul-template-page-btn"
        onClick={() => setPage(totalPages)}
        disabled={page === totalPages}
      >
        {">>"}
      </button>

    </div>
  );
}